import { Link } from 'react-router-dom';
import LegalPage, { LEGAL_CONTACT, LegalSection } from './LegalPage';

const mail = <a href={`mailto:${LEGAL_CONTACT}`}>{LEGAL_CONTACT}</a>;

const sections: LegalSection[] = [
  { id: 'service', heading: 'The service', body: <>
    <p>FluxWatch is a third-party risk management platform by FluxVell. It assesses the publicly visible security of the
      vendors you add, and helps you send questionnaires, track remediation and produce reports. By creating a workspace
      you agree to these Terms on behalf of your organisation.</p>
  </> },
  { id: 'accounts', heading: 'Your account', body: <>
    <ul>
      <li>Give accurate details when you sign up and keep them up to date.</li>
      <li>Keep your sign-in details private. You are responsible for activity in your workspace.</li>
      <li>Workspace admins decide who has access. Remove people who leave your organisation.</li>
    </ul>
  </> },
  { id: 'plans', heading: 'Plans', body: <>
    <p>New workspaces start on a free plan with the limits shown in the product. Paid plans include the features and
      limits agreed with you.</p>
  </> },
  { id: 'acceptable-use', heading: 'Acceptable use', body: <>
    <p>Use FluxWatch only to assess organisations you have a genuine business reason to evaluate, such as your vendors,
      prospective vendors and your own company. Do not use it to attack or disrupt any system, to harass anyone, or to get
      around plan limits or access other workspaces.</p>
  </> },
  { id: 'your-data', heading: 'Your data', body: <>
    <p>The data you put into FluxWatch belongs to you. We use it only to provide the service to you. Our{' '}
      <Link to="/privacy">Privacy Policy</Link> explains how we handle personal information.</p>
  </> },
  { id: 'ai', heading: 'AI features', body: <>
    <p>FluxWatch is an AI-powered platform. AI output can contain mistakes, so review it before relying on it.</p>
  </> },
  { id: 'results', heading: 'Assessment results', body: <>
    <p>Scores and findings reflect what could be observed at the time of the assessment. Use them as one input to your own
      risk decisions.</p>
  </> },
  { id: 'closing', heading: 'Closing your account', body: <>
    <p>You can stop using FluxWatch at any time. We may suspend accounts that break these Terms.</p>
  </> },
  { id: 'changes', heading: 'Changes', body: <>
    <p>We may update these Terms from time to time. The latest version is always on this page.</p>
  </> },
  { id: 'contact', heading: 'Contact', body: <>
    <p>Questions about these Terms: {mail}.</p>
  </> },
];

export default function Terms() {
  return (
    <LegalPage title="Terms of Service" sections={sections}
      intro={<p>The basic rules for using FluxWatch.</p>} />
  );
}
